import React, { useState, useEffect } from "react";
import DualRangeSlider from "./DualRangeSlider.jsx";

export default function FilterPanel({
  showFilters,
  setShowFilters,
  filters,
  updateFilter,
  clearAllFilters,
  user
}) {
  const hasActiveFilters = Object.keys(filters).length > 0;
  const LATEST_YEAR = 2024;

  const [rankRangeValues, setRankRangeValues] = useState([1, 1000]);

  useEffect(() => {
    setRankRangeValues([
      filters.popularityRange ? filters.popularityRange.min : 1,
      filters.popularityRange ? filters.popularityRange.max : 1000
    ]);
  }, [filters.popularityRange]);

  useEffect(() => {
    const handler = setTimeout(() => {
      const currentMin = filters.popularityRange ? filters.popularityRange.min : 1;
      const currentMax = filters.popularityRange ? filters.popularityRange.max : 1000;
      if (currentMin !== rankRangeValues[0] || currentMax !== rankRangeValues[1]) {
        const payload =
          rankRangeValues[0] === 1 && rankRangeValues[1] >= 1000 ? null : { min: rankRangeValues[0], max: rankRangeValues[1] };
        updateFilter('popularityRange', payload);
      }
    }, 1000);
    return () => clearTimeout(handler);
  }, [rankRangeValues]);

  return (
    <div className="filter-panel">
      <div className="filter-header">
        <button
          className={`filter-toggle ${showFilters ? 'active' : ''}`}
          onClick={() => setShowFilters(!showFilters)}
        >
          <span className="filter-icon">⚙️</span>
          <span>Customize Names</span>
          {hasActiveFilters && (
            <span className="filter-badge">{Object.keys(filters).length}</span>
          )}
        </button>
        {hasActiveFilters && (
          <button className="clear-filters-btn" onClick={clearAllFilters}>
            ✕ Clear All
          </button>
        )}
      </div>
      {showFilters && (
        <div className="filter-content">
          <div className="filter-grid">
            <div className="filter-group">
              <label className="filter-label">📅 Popularity Era</label>
              <select
                value={filters.popularityEra || ''}
                onChange={e => updateFilter('popularityEra', e.target.value || null)}
                className="filter-select"
              >
                <option value="">Any Era</option>
                <option value="vintage">Vintage (Pre-1950)</option>
                <option value="classic">Classic (1950-1990)</option>
                <option value="modern">Modern (1990-2010)</option>
                <option value="trending">Trending (2010+)</option>
              </select>
            </div>
            <div className="filter-group">
              <label className="filter-label">📏 Name Length</label>
              <select
                value={filters.nameLength || ''}
                onChange={e => updateFilter('nameLength', e.target.value || null)}
                className="filter-select"
              >
                <option value="">Any Length</option>
                <option value="short">Short (3-5 letters)</option>
                <option value="medium">Medium (6-8 letters)</option>
                <option value="long">Long (9+ letters)</option>
              </select>
            </div>
            <div className="filter-group">
              <label className="filter-label">🌍 Cultural Background</label>
              <select
                value={filters.culturalBackground || ''}
                onChange={e => updateFilter('culturalBackground', e.target.value || null)}
                className="filter-select"
              >
                <option value="">Any Background</option>
                <option value="european">European Heritage</option>
                <option value="hispanic">Hispanic Heritage</option>
                <option value="black">Black Heritage</option>
                <option value="asian">Asian Heritage</option>
                <option value="nativeamerican">Native American Heritage</option>
              </select>
            </div>
            <div className="filter-group">
              <label className="filter-label">⚧️ Gender Association</label>
              <select
                value={filters.genderAssociation || ''}
                onChange={e => updateFilter('genderAssociation', e.target.value || null)}
                className="filter-select"
              >
                <option value="">Any Association</option>
                <option value="traditional">Traditional (Single Gender)</option>
                <option value="unisex">Unisex Names</option>
              </select>
            </div>

            <div className="filter-group">
              <label className="filter-label">📈 {LATEST_YEAR} Popularity Rank</label>
              <DualRangeSlider
                values={rankRangeValues}
                onChange={setRankRangeValues}
              />
            </div>
            {/* {user.accepted && user.accepted.length > 0 && (
              <div className="filter-group">
                <label className="filter-label">💖 Similar to Favorites</label>
                <div className="filter-checkbox">
                  <input
                    type="checkbox"
                    id="similarToFavorites"
                    checked={filters.similarToFavorites || false}
                    onChange={e => updateFilter('similarToFavorites', e.target.checked || null)}
                  />
                  <label htmlFor="similarToFavorites">
                    {`Show names similar to your ${user.accepted.length} favorites`}
                  </label>
                </div>
              </div>
            )} */}
          </div>
        </div>
      )}
    </div>
  );
}

